const alias = 'CHECKLIST';

export const FETCH_DOCUMENT_CHECKLIST_REQUEST = `FETCH_${alias}S_REQUEST`;
export const FETCH_DOCUMENT_CHECKLIST_SUCCESS = `FETCH_${alias}S_SUCCESS`;
export const FETCH_DOCUMENT_CHECKLIST_FAILURE = `FETCH_${alias}S_FAILURE`;
